import VueRouter, { RawLocation, Route } from 'vue-router';
/* eslint-disable import/no-unresolved */
import { ErrorHandler } from 'vue-router/types/router';

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(
  location: RawLocation,
  onComplete?: (route: Route) => void | undefined,
  onAbort?: ErrorHandler | undefined,
): Promise<Route> {
  if (onComplete || onAbort) {
    return (originalPush.call(this, location, onComplete, onAbort) as unknown as Promise<Route>);
  }

  return ((originalPush.call(this, location) as unknown) as Promise<Route>)
    .catch((error: Error) => {
      const navFailureType = VueRouter.NavigationFailureType;
      if (
        VueRouter.isNavigationFailure(error, navFailureType.duplicated)
        || VueRouter.isNavigationFailure(error, navFailureType.redirected)
      ) {
        // resolve error, typing is wrong, just to overwrite
        return error as unknown as Route;
      }

      // must remain
      console.error(error);

      // rethrow error, typing is wrong, just to overwrite
      return Promise.reject(error) as PromiseLike<Route>;
    });
};

export {
  VueRouter,
};
